import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useGetContracts, useGetEmployees } from '../../../../../../queries';
import { ControlledSelect } from '../../../../../shared';
import ValidFromAndToSection from './ValidFromAndToSection';

const EndingBenefitsSelection = () => {
  const { control } = useFormContext();
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.procedures.reports'
  });
  const { data: employees } = useGetEmployees();
  const { data: contracts } = useGetContracts();

  return (
    <>
      <ValidFromAndToSection />
      <ControlledSelect
        variant="outlined"
        control={control}
        name="emp_id_list"
        label={t('employee')}
        options={employees ?? []}
      />
      <ControlledSelect
        variant="outlined"
        control={control}
        name="contract_list"
        label={t('contract')}
        options={contracts ?? []}
      />
    </>
  );
};

export default EndingBenefitsSelection;
